import React, { useState } from 'react';
import { Card, Tabs, Breadcrumb, Space } from 'antd';
import {
  CheckCircleOutlined,
  SafetyCertificateOutlined,
  VideoCameraOutlined,
  HomeOutlined,
} from '@ant-design/icons';
import AppLayout from '../components/AppLayout';
import Verification from './Verification';
import CertificationVerification from './CertificationVerification';

const { TabPane } = Tabs;

const UnifiedVerification = () => {
  const [activeTab, setActiveTab] = useState('video');

  return (
    <AppLayout activeMenu="/verification">
      <div className="unified-verification-page">
        {/* Breadcrumb */}
        <Breadcrumb style={{ marginBottom: 16 }}>
          <Breadcrumb.Item href="/">
            <HomeOutlined />
          </Breadcrumb.Item>
          <Breadcrumb.Item>Verifikasi</Breadcrumb.Item>
        </Breadcrumb>

        {/* Main Content Card */}
        <Card
          title={
            <Space>
              <CheckCircleOutlined />
              <span>Verifikasi Konten</span>
            </Space>
          }
          style={{ minHeight: '80vh' }}
        >
          <Tabs activeKey={activeTab} onChange={setActiveTab} size="large">
            <TabPane
              tab={
                <span>
                  <VideoCameraOutlined />
                  Verifikasi Video
                </span>
              }
              key="video"
            >
              {/* Render Verification component in embedded mode */}
              <Verification embedded={true} />
            </TabPane>
            <TabPane
              tab={
                <span>
                  <SafetyCertificateOutlined />
                  Verifikasi Sertifikasi
                </span>
              }
              key="certification"
            >
              {/* Render Certification Verification without layout wrapper */}
              <div style={{ marginTop: 16 }}>
                <CertificationVerification embedded={true} />
              </div>
            </TabPane>
          </Tabs>
        </Card>
      </div>
    </AppLayout>
  );
};

export default UnifiedVerification;
